import { format, fromUnixTime, getUnixTime } from 'date-fns'

export let dateToTs = function (dt) {
  return getUnixTime(dt)
}

export let formatUnixTimestamp = function (ts, datepicker = false) {
  var dateFormat = 'MMMM do, yyyy h:mm a'
  if (datepicker) {
    dateFormat = "yyyy-MM-dd'T'HH:mm"
  }
  return format(fromUnixTime(ts), dateFormat)
}

// JS Dates are automatically converted to local timezone
export let formatDate = function (dateStr, options = {}) {
  var dateFormat = 'M/d/yyyy'
  var timeFormat = 'h:mmaaaaa'
  var localDate = new Date(dateStr)
  var o = {
    showDate: true,
    showTime: true,
    formatStr: null,
  }

  // Apply option overrides
  Object.assign(o, options)

  // If formatStr given, just use that. Otherwise, use easy options
  if (!o.formatStr) {
    o.formatStr = dateFormat + ' ' + timeFormat

    // Only showing date or time.
    if (o.showDate && !o.showTime) {
      o.formatStr = dateFormat
    } else if (!o.showDate && o.showTime) {
      o.formatStr = timeFormat
    }
  }

  return format(localDate, o.formatStr)
}

export let formatDatepicker = function (dateStr, options = {}) {
  let dt = new Date(`${dateStr} MDT`)
  return dt.toISOString()
}

export let formatDateForDb = function (dateStr, options = {}) {
  var dateFormat = "yyyy-MM-dd'T'hh:mm:ss'Z'"
  var localDate = new Date(dateStr)

  return format(localDate, dateFormat)
}

export let formatInt = function (price) {
  return Math.round(price * 100)
}

export let formatPrice = function (price, hideDecimals) {
  let formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  })

  if (hideDecimals) {
    return formatter.format(price / 100).replace(/\.00/g, '')
  }
  return formatter.format(price / 100)
}

export let validateAddresses = function (input, output) {
  let outZip = output.zip.substring(0, 5)

  return (
    input.address.toLowerCase() === output.address.toLowerCase() &&
    input.city.toLowerCase() === output.city.toLowerCase() &&
    input.state.toLowerCase() === output.state.toLowerCase() &&
    input.zip.startsWith(outZip)
  )
}

export let scrollToY = function (pos) {
  document.body.scrollTop = pos // For Safari
  document.documentElement.scrollTop = pos // For Chrome, Firefox, IE and Opera
}

export let formatTitle = function (title) {
  // replaceAll is for newer browsers
  return title.replace(/ /g, '-').replace(/\//g, '-')
}
